import type { CommercialInvoiceAnalysisResult } from "./types";

export type CiCheckPhase = "idle" | "pending" | "running" | "done" | "error";

export interface CiDualCheckRunState {
  heuristic: CiCheckPhase;
  deepCheck: CiCheckPhase;
  heuristicError?: string;
  deepCheckError?: string;
  /** Latest merged analysis while checks complete (before booking refetch). */
  liveResult?: CommercialInvoiceAnalysisResult | null;
}

export const CI_DUAL_CHECK_IDLE: CiDualCheckRunState = {
  heuristic: "idle",
  deepCheck: "idle",
};

export const isCiDualCheckActive = (state: CiDualCheckRunState): boolean =>
  state.heuristic === "running" ||
  state.heuristic === "pending" ||
  state.deepCheck === "running" ||
  state.deepCheck === "pending";

export const isCiDualCheckRunning = (state: CiDualCheckRunState): boolean =>
  state.heuristic === "running" || state.deepCheck === "running";
